import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
@Component({
  selector: 'app-creat-team',
  templateUrl: './creat-team.component.html',
  styleUrls: ['./creat-team.component.css']
})
export class CreatTeamComponent implements OnInit {
teamForm:FormGroup
  empList: any;
  userData: any;
  clientId: any;
  submitted: boolean=false;
  constructor(  private fb: FormBuilder,private commonService:CommonService) { 
    this.teamForm = this.fb.group({
    teamName:['',Validators.required],
    manager:['0',Validators.required],
    description:['',Validators.required],
    });
  }

  ngOnInit(): void {
    let userDataObj = localStorage.getItem('userData');
    if (userDataObj) {
      try {
        this.userData = JSON.parse(userDataObj);
        if(this.userData.attributes.role === 'clients'){
          this.clientId=this.userData.email;
        }
      } catch (error) {

      }
    }
    this.getAllEmployees();
  }

  getAllEmployees() {
    this.commonService.getRequestWithToken(`users/clientid/${this.clientId}?role=manager`, []).then((resp: any) => {
         this.empList = resp.data;
        //  this.empList = this.empList.filter(customer=>!customer.administrator && customer.userLimit === 0); 
         if(this.empList.isDealer) {
          debugger
           const allowedRoles = 'manager'
           this.empList = this.empList.filter(customer => {
             const role = customer.attributes?.role;
             return role && allowedRoles.includes(role.toLowerCase());
           })   
         }else  {
          debugger
           const allowedRoles = 'manager'
           this.empList = this.empList.filter(customer => {
          const role = customer.attributes?.role;
            return role && allowedRoles.includes(role.toLowerCase());
 });
 console.log('all manager=>',this.empList);
        
       }
     });

   }
getManagerDetails(event:any){
}
get teamformControl() {
  return this.teamForm.controls;
}
submit(){
  if (this.teamForm.invalid) {
    return;
  }
  console.log('team form=>',this.teamForm)
  this.submitted = true;

  const requestBody ={
    manager: this.teamForm.value.manager,
    teamName: this.teamForm.value.teamName,
    clientid: this.clientId,
    description: this.teamForm.value.description,
    status: "open",
  }   
  this.commonService.postRequestWithToken('clientteam', requestBody).then(
    (resp) => {
      console.log('Response:', resp);
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Team created successfully',
        showConfirmButton: false,   
        timer: 1500,
      });
      this.teamForm.reset();
      this.commonService.commonModel.next(false);
    },
    (error) => {
      console.error('Error:', error);
      this.commonService.commonModel.next(false);
    }
  );
  
}   
  closeModal() {
    this.commonService.commonModel.next(false);
  }
}
